import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const FencingRepository = RepositoryFactory.get('RailwayRepository')['FencingRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get, create } = DefaultStoreActions(FencingRepository)

export const STORE_MODULE_NAME = 'fencing';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
        create: create,
    },
}
